var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternal2List(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Internal_2_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal_2_List",
    "data-name": "Internal 2_List",
    clipPath: "url(#clip-Internal_2_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_664",
    "data-name": "Ellipse 664",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33366",
    "data-name": "Path 33366",
    d: "M1.77,1A.768.768,0,0,0,1,1.77V6.007a.768.768,0,0,0,.77.77H6.007a.768.768,0,0,0,.77-.77V4.852h-.77V6.007H1.77V1.77H6.007v.77h.77V1.77A.768.768,0,0,0,6.007,1M4.081,3.311a.768.768,0,0,0-.77.77V5.237h.77V4.081H8.318V8.318H4.081v-.77h-.77v.77a.768.768,0,0,0,.77.77H8.318a.768.768,0,0,0,.77-.77V4.081a.768.768,0,0,0-.77-.77H4.081",
    transform: "translate(4.456 4.456)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal2List);
export default __webpack_public_path__ + "static/media/Internal 2_List.9774762f412919ba1b1ce1c68955d70d.svg";
export { ForwardRef as ReactComponent };